export const MIN_WIDTH_TAG = 7
